<template>
  <div class="scraped-value-display">
    <!-- S3 URL: show View + Download -->
    <template v-if="isS3Url">
      <v-btn color="primary" class="navigation-btn" @click="openPreview">View file</v-btn>
      <v-btn color="primary" class="navigation-btn" @click="downloadFile">Download file</v-btn>
      <filePreviewModal :dialog="previewOpen" :data="previewData" @close="previewOpen = false" />
    </template>

    <!-- Non-S3 URL: show Website link -->
    <v-btn v-else-if="isUrl" color="primary" class="navigation-btn" @click="openLink">Website link</v-btn>

    <!-- Plain text -->
    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
import filePreviewModal from '@/components/filePreviewModal.vue'

export default {
  name: 'ScrappedValueDisplay',
  components: {
    filePreviewModal
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      previewOpen: false
    }
  },
  computed: {
    isUrl () {
      if (!this.value) return false
      try {
        const url = new URL(this.value)
        return url.protocol === 'http:' || url.protocol === 'https:'
      } catch {
        return false
      }
    },
    isS3Url () {
      if (!this.value) return false
      return /amazonaws\.com/.test(this.value) || /rts3\.0/.test(this.value)
    },
    previewData () {
      return { file_path: this.value }
    }
  },
  methods: {
    openPreview () {
      this.previewOpen = true
    },
    downloadFile () {
      window.open(this.value, '_blank')
    },
    openLink () {
      window.open(this.value, '_blank')
    }
  }
}
</script>

<style scoped>
.scraped-value-display {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
